import { render } from "./NewStatisticCard.vue?vue&type=template&id=615639f9"
import script from "./NewStatisticCard.vue?vue&type=script&lang=js"
export * from "./NewStatisticCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__